import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";

const EXPLORE = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Us" },
  { to: "/recruiting", label: "Recruiting" },
  { to: "/schedule", label: "Schedule" },
  { to: "/roster", label: "Roster" },
  { to: "/camps", label: "Camps" },
  { to: "/contact", label: "Contact Us" },
];

const PROGRAMS = ["Football", "Men's Basketball", "Women's Basketball", "College Placement", "Camps"];

export default function Footer() {
  return (
    <footer data-testid="footer-container" className="relative border-t border-white/10 bg-navy-850">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <div className="flex items-center gap-3">
            <img src="/logo.png" alt="ASA logo" className="h-14 w-14 object-contain" />
            <div className="leading-none">
              <p className="font-display text-xl font-extrabold uppercase text-white">Alabama Bulldogs</p>
              <p className="mt-1 font-mono text-[10px] font-semibold uppercase tracking-[0.32em] text-ice">
                Sports Academy
              </p>
            </div>
          </div>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-400">
            A post-graduate sports academy in Tuskegee, Alabama — developing stronger competitors, better students,
            and individuals of character prepared to succeed in college and beyond.
          </p>
          <p data-testid="footer-address" className="mt-6 flex items-start gap-2 text-sm text-silver-dim">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-crimson" />
            4280 US-29, Tuskegee, Alabama
          </p>
        </div>

        <div data-testid="footer-nav-links">
          <p className="eyebrow mb-5">Explore</p>
          <ul className="space-y-3">
            {EXPLORE.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="text-sm text-slate-300 transition-colors hover:text-ice"
                  data-testid={`footer-link-${l.to.replace("/", "") || "home"}`}
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="eyebrow mb-5">Programs</p>
          <ul className="space-y-3">
            {PROGRAMS.map((p) => (
              <li key={p} className="text-sm text-slate-300">
                {p}
              </li>
            ))}
          </ul>
          <p className="mt-6 text-sm leading-relaxed text-slate-500">
            The fastest way to reach our staff is through any form on this site — we answer every submission.
          </p>
        </div>
      </div>

      <div className="border-t border-white/5 py-6 text-center">
        <p className="font-mono text-xs uppercase tracking-widest text-slate-600">
          © {new Date().getFullYear()} Alabama Bulldogs Sports Academy · Bridge the gap. Earn the offer. ·{" "}
          <Link to="/admin" data-testid="footer-staff-link" className="transition-colors hover:text-ice">
            Staff Login
          </Link>
        </p>
      </div>
    </footer>
  );
}
